import { useMemo } from 'react';
import { useSizeAndWidthContext } from '../context';
import { hasMatchingSizeVariant, isValueDisplayed } from '../utils';

export function useFilteredWidths() {
  const { selectedSize, isSubdomainOutlet, uniqueWidths, variants } = useSizeAndWidthContext();
  return useMemo(() => {
    const widthsWithMatchingSizeVariants = uniqueWidths.filter(
      (productWidth) => productWidth && hasMatchingSizeVariant(selectedSize, productWidth, variants),
    );
    return widthsWithMatchingSizeVariants.filter((width) =>
      isValueDisplayed(selectedSize, width, variants, isSubdomainOutlet),
    );
  }, [isSubdomainOutlet, selectedSize, uniqueWidths, variants]);
}
